function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.75,40.12c0,3.11,2.52,5.62,5.62,5.62h31.25c1.04,0,1.88.84,1.88,1.88s-.84,1.88-1.88,1.88h-31.25c-5.18,0-9.38-4.2-9.38-9.38v-18.75c0-1.04.84-1.88,1.88-1.88s1.88.84,1.88,1.88v18.75ZM19.5,14.5h32.5c2.76,0,5,2.24,5,5v17.5c0,2.76-2.24,5-5,5H19.5c-2.76,0-5-2.24-5-5v-17.5c0-2.76,2.24-5,5-5ZM19.5,19.5v5c2.76,0,5-2.24,5-5h-5ZM19.5,37h5c0-2.76-2.24-5-5-5v5ZM32.62,33.66c1.93,1.12,4.32,1.12,6.25,0,1.93-1.12,3.12-3.18,3.12-5.41s-1.19-4.3-3.12-5.41c-1.93-1.12-4.32-1.12-6.25,0-1.93,1.12-3.12,3.18-3.12,5.41s1.19,4.3,3.12,5.41ZM52,24.5v-5h-5c0,2.76,2.24,5,5,5ZM47,37h5v-5c-2.76,0-5,2.24-5,5Z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 64 64"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/cashInOut.de6bd331.svg";
export { SvgComponent as ReactComponent };